import { Pipe, PipeTransform } from '@angular/core';
import { PluralizedListPipe } from '../other/pluralized-list.pipe';
import { CobMetaPipe } from './cob.pipe';
import { QuoteAddon } from '@lockton-apps/shared/interfaces';
import { compact, map } from 'lodash';
import { CobMeta } from '@lockton-apps/shared/util/constants';

@Pipe({
  name: 'pluralizedAddonsList',
  standalone: true,
})
export class PluralizedAddonsListPipe implements PipeTransform {
  constructor(
    private readonly pluralizedList: PluralizedListPipe,
    private readonly cobMeta: CobMetaPipe
  ) {}

  transform(addons: QuoteAddon[], offline: boolean): string {
    return this.pluralizedList.transform(
      compact(
        map(addons, (addon: QuoteAddon) => {
          const meta: CobMeta = this.cobMeta.transform(addon.classOfBusinessId);

          return meta.offline === offline ? meta.title : null;
        })
      )
    );
  }
}
